<script setup>
import AppButton from '@/components/ui/AppButton/AppButton'
import AppIcon from '@/components/ui/AppIcon/AppIcon'

defineOptions({
  name: 'CommentReplyButton'
})

const emit = defineEmits({
  click: null
})
</script>

<template>
  <AppButton
    class="cr-Button"
    data-testid="reply-button"
    size="sm"
    type="link-secondary"
    @click="emit('click')"
  >
    <span class="cr-Button_Content">
      <AppIcon class="cr-Button_Icon" height="24" icon-name="reply" width="24" />
      {{ $t('action.reply') }}
    </span>
  </AppButton>
</template>

<style lang="scss" scoped>
.cr-Button {
  transition: color $transition-fast;
  &_Content {
    display: flex;
    align-items: center;
    gap: 4px;
  }

  @media (any-hover: hover) {
    &:hover {
      color: $primary-color-next;
    }
  }
}

.cr-Button_Icon {
  border-radius: $border-radius-sm-next;
  transition: color $transition-fast ease-in-out, background-color $transition-fast ease-in-out;

  &:not(.cr-Button:hover &) {
    color: $dark-2;
  }

  .cr-Button:hover & {
    background-color: $grey-3-next;
  }
}
</style>
